export default __webpack_public_path__ + "static/media/LED Digital Display.6c3d0369.JPG";